import { render, staticRenderFns } from "./RankingVolumeOriginadoPorCriterio.vue?vue&type=template&id=44f3312d&lang=pug"
import script from "./RankingVolumeOriginadoPorCriterio.vue?vue&type=script&lang=js"
export * from "./RankingVolumeOriginadoPorCriterio.vue?vue&type=script&lang=js"
import style0 from "./RankingVolumeOriginadoPorCriterio.vue?vue&type=style&index=0&id=44f3312d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports